/**
 * antd v4 date/time pickers backed by dayjs instead of the default moment build.
 *
 * antd v4 ships moment-based pickers; to drop moment we regenerate them with
 * rc-picker's dayjs config (the same mechanism the codebase already uses for its
 * date-fns pickers via `rc-picker/es/generate/dateFns`). `generatePicker`
 * returns a DatePicker carrying `.RangePicker` and `.TimePicker` statics.
 *
 * For a time-range use `<RangePicker picker="time" />` — that is exactly what
 * antd's `TimePicker.RangePicker` is under the hood.
 */
import generatePicker from 'antd/es/date-picker/generatePicker';
import type { GenerateConfig } from 'rc-picker/es/generate';
import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';

import type { Dayjs } from 'app/utils/dayjs';

// rc-picker ships its own nested dayjs (1.11.x) whose type lacks our extended
// plugin methods, so the config's DateType is structurally narrower than our
// Dayjs. Both are dayjs 1.11 at runtime (interchangeable via $isDayjsObject),
// so the cast is safe — it only reconciles the two dayjs *type* identities.
export const DatePicker = generatePicker<Dayjs>(
  dayjsGenerateConfig as unknown as GenerateConfig<Dayjs>
);
export const { RangePicker, TimePicker } = DatePicker;
